<div
  class="flex items-center bg-white border border-gray-200 rounded-full p-1 m-1"
  [ngClass]="{ 'bg-gray-100': disabled() }"
>
  @if(icon){
  <div class="size-6 me-1">
    <img class="inline-block rounded-full" alt="icon" [src]="icon" />
  </div>

  }
  <div
    class="whitespace-nowrap text-gray-800 max-w-[130px] truncate"
    [ngClass]="{ 'ml-1': !icon }"
  >
    {{ label() }}
  </div>
  @if(removable()){
  <div
    class="inline-flex shrink-0 justify-center items-center size-5 ms-2 rounded-full text-gray-800 bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400 text-sm cursor-pointer"
    (click)="handleRemove($event)"
    [ngClass]="{ 'hover:bg-gray-300': !disabled() }"
  >
    <svg
      class="shrink-0 size-3"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </svg>
  </div>
  }
</div>
